<template>
  <div style="margin-bottom:15px;margin-top:15px;">
    <div style="display: flex; flex-direction: row;align-items: center;justify-content: center;">
    <div v-for="model in question.answers" v-bind:key="model.uid">
      <label
          :for="question.uid" v-bind:class="{ selected: model.selected }">
      </label>
      <div v-show="!$store.getters.getPhoneVerifySession" class="form-group" id="inputPhone">
        <input v-model="model.value"
               class="form-control"
               placeholder="+380xxxxxxxxx"
               :name="question.uid"
               v-mask="inputMask"
        >
        <div style="margin-top:10px">
          <button v-bind:style="{ background: $store.getters.getButtonColor}"
                  v-on:click="sendCode(model)" type="button" class="btn btn-primary btn-lg ripple">{{ $t("ui.receiveCode") }}</button>
        </div>
      </div>
      <div class="text-center">
          <div v-show="$store.getters.getPhoneValidateResult === 0 || $store.getters.getPhoneValidateResult === 2" id="inputCode">

            <v-otp-input
                ref="otpInput"
                input-classes="otp-input form-control form-40-px"
                separator="-"
                :num-inputs="4"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-change="handleOnChange"
                @on-complete="handleOnComplete"
            />

            <div style="margin-top:10px">
                <button v-bind:style="{ background: $store.getters.getButtonColor}"
                        v-on:click="validateCode(model)" type="button" class="btn btn-primary btn-lg ripple">{{ $t("ui.confirmCode") }}
                </button>
              </div>
            </div>

          </div>
        </div>

        <div v-if="$store.getters.getPhoneValidateResult === 1">
            <span style="font-weight:bold;color:#2eb62e;">
              {{ $t("ui.codeValid") }}
            </span>
        </div>
      </div>
    </div>
</template>

<script>

import Vue from 'vue';
import OtpInput from "@bachdgvn/vue-otp-input";

Vue.component("v-otp-input", OtpInput);

export default {
  name: 'phone-verify',
  props: ['question'],
  data() {
    return {
      inputCode: '',
      inputNumber: false,
      inputMask: '+380999999999'
    }
  },
  methods: {
    handleOnComplete(value) {
      this.inputCode = value;
      console.log('OTP completed: ', value);
    },
    handleOnChange(value) {
      this.inputCode = value;
    },
    sendCode: function (model) {

      document.getElementById('inputPhone').classList.remove('has-error')

      if(!model.value || model.value < 13) {
        document.getElementById('inputPhone').classList.add('has-error')
      } else {

        document.getElementById('inputPhone').classList.add('has-success')

        const data = {
          phone: model.value
        }

        this.$store.dispatch('SEND_VERIFY_CODE_REQUEST', data);
      }

    },
    validateCode: function (model) {

      document.getElementById('inputCode').classList.remove('has-error')

      const data = {
        code: this.inputCode,
        uid: this.$store.getters.getPhoneVerifySession
      }

      this.$store.dispatch('SEND_VALIDATE_CODE_REQUEST', data).then(() => {

        if (this.$store.getters.getPhoneValidateResult === 1) {

          model.verify_code_invalid = false;

        } else {
          document.getElementById('inputCode').classList.add('has-error')
        }
      });
    }
  },
  components: {}
}
</script>

<style scoped lang="less">
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;

  &.error {
    border: 1px solid red !important;
  }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
